import React, { useContext } from 'react'
import { ThemeContext } from "../../Context/ThemeContext.js";
import './Modal.css'
const Modal = (props) => {

    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;


    return props.trigger ? (
        <div className='modalWrapper'>
            <div className={`modal-bg ${darkMode ? 'dark-modal-bg' : 'light-modal-bg'}`}>
                <div className="modal-content">
                    <div className="top-modal">
                        <div className="m-name"><span>{props.cname}</span><img src={props.icon} alt="" /></div>
                        <div className={`${darkMode ? 'm-wallet dark-wallet' : 'm-wallet'}`}>
                            <div className="balance">
                                <span>Available in Wallet: </span><span>{props.avbal}</span>
                            </div>
                            <div className="staked">
                                <span>Staked: </span><span>{props.mystakes}</span>
                            </div>
                            <div className="earned">
                                <span>Earned: </span><span>{props.earnings}</span>
                            </div>
                        </div>
                        <div className="option">
                            <input type="checkbox" /><span>Stake</span><input type="checkbox" /><span>Unstake</span>
                        </div>
                    </div>
                    <div className="mid-modal">
                        <div>Enter Deposite Amount</div>
                        <div className='button modal-btn'>
                            <span>Max</span>
                        </div>
                    </div>
                    <div className="bottom-modal">
                        <div className='button bottom-modal-btn'>
                            <span>Approve</span>
                        </div>
                        <div className='button bottom-modal-btn'>
                            <span>Stake</span>
                        </div>
                        <div className='bottom-claim-btn'>
                            <span>Stake</span>
                            <div className="modal-foot">
                                <span>{props.cname}</span>
                                <img src="/link.svg" alt="" />
                            </div>
                            <div className="close" onClick={() => { props.showmodal() }}>
                                X
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : '';
}

export default Modal